(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared-2/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared-2/assets/javascripts/prescript.js');

'use strict';

svs.grassroots = svs.grassroots || {};
svs.grassroots.components = svs.grassroots.components || {};
svs.grassroots.components.searchbar_section = svs.grassroots.components.searchbar_section || {};
svs.grassroots.components.start_info_section = svs.grassroots.components.start_info_section || {};
svs.grassroots.components.receiver = svs.grassroots.components.receiver || {};
svs.grassroots.components.result = svs.grassroots.components.result || {};
svs.grassroots.components.search_results = svs.grassroots.components.search_results || {};
svs.grassroots.pages = svs.grassroots.pages || {};
svs.grassroots.store = svs.grassroots.store || {};
svs.grassroots.utils = svs.grassroots.utils || {};
svs.grassroots.utils.omsKey = svs.grassroots.utils.omsKey || {};
svs.grassroots.context = svs.grassroots.context || {};

svs.grassroots.shared = svs.grassroots_shared_2 || {};
svs.grassroots.shared.data = svs.grassroots.shared.data || {};
svs.grassroots.shared.data.config = svs.grassroots.shared.data.config || {};
svs.grassroots.tenant = svs.grassroots.shared.data.isCorporateSite ? 'neutral' : svs.core.detect.tenant('lb') ? 'sport' : 'tur';
svs.grassroots.background = svs.grassroots.shared.data.isCorporateSite ? 'bg-red-100' : svs.core.detect.tenant('lb') ? 'bg-sport-100' : 'bg-tur-100';
const sanitise = str => str.replace(/å/g, 'a').replace(/Å/g, 'A').replace(/ä/g, 'a').replace(/Ä/g, 'A').replace(/ö/g, 'O').replace(/Ö/g, 'O').replace(/ /g, '-').toLowerCase();
const single = 'forening';
svs.grassroots.links = {
  start: '/',
  singlePattern: "/".concat(single, "/:id"),
  single: (id, shortname) => "/".concat(single, "/").concat(id, "-").concat(sanitise(shortname || '')),
  search: '/sok',
  query: q => "/sok?q=".concat(q),
  sanitise,
  result: '/sagickdet/:year/:view?/:viewDetail?',
  marketing: '/marknadsforing'
};

svs.grassroots.utils.omsKey.getOmsKey = function () {
  let omskey;
  switch (svs.core.data.capabilities.channel) {
    case 'ios-hybrid-mobile':
    case 'android-hybrid-mobile':
      omskey = '36';
      break;
    case 'ios-hybrid-tablet':
    case 'android-hybrid-tablet':
      omskey = '37';
      break;
    case 'web-mobile':
      omskey = '31';
      break;
    case 'web-tablet':
      omskey = '34';
      break;
    case 'web-desktop':
      omskey = '10';
      break;
    default:
      omskey = '31';
  }
  return omskey;
};

 })(window);